module.exports = __webpack_public_path__ + "img/shield-02.8e75dbf5.svg";